import { Seo } from '@/components/site/seo';
import { ContactSection } from '@/components/site/sections/contact';
import { BannerHero } from '@/components/site/banner-hero';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function ContactPage() {
  const { locale, dict, settings } = useLocaleContext();

  return (
    <>
      <Seo
        locale={locale}
        title={dict.contact.title}
        description={dict.contact.subtitle}
        path="/contacto"
        image="/banners/banner-web-1.jpg"
      />
      <BannerHero image="/banners/banner-web-1.jpg" title={dict.contact.title} />
      <ContactSection locale={locale} dict={dict} settings={settings} compact />
    </>
  );
}
